export const formatIsoDate = (isoDate: string) => {
  const date = new Date(isoDate);

  const month = date.getMonth() + 1;
  const monthString: string = month < 10 ? `0${month}` : `${month}`;

  const year = date.getFullYear();
  const yearString: string = year.toString();

  const day = date.getDate();
  const dayString: string = day < 10 ? `0${day}` : `${day}`;

  const formattedDate = `${yearString}-${monthString}-${dayString}`;
  return formattedDate;
};

export const stringToDate = (
  dateString: string | undefined
): Date | undefined => {
  if (!dateString) {
    return undefined;
  }
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return undefined;
  }
  return date;
};

export const stringToDateString = (dateString?: string) => {
  if (!dateString) {
    return "";
  }
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return "";
  }
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const monthString: string = month < 10 ? `0${month}` : `${month}`;
  const day = date.getDate();
  const dayString: string = day < 10 ? `0${day}` : `${day}`;
  return `${year}-${monthString}-${dayString}`;
};
